/**
 * Este método itera sobre un objeto hasta encontrar la ruta especificada
 *
 * @example
 *
  const obj = {
    a: {
      b: {
        c: {
          d: "d"
        }
      }
    }
  };

  console.log(getValueByPath(obj,'a.b.c')) // { d: 'd' }
  console.log(getValueByPath(obj,'a.b.c.d')) // 'd'
 *
 */
export function getValueByPath<T>(
  obj: object,
  path: string | string[],
  separator = '.',
): T | undefined {
  const actualPath = typeof path === 'string' ? path.split(separator) : path;
  if (typeof obj !== 'object' || !obj) {
    if (actualPath.length === 0) return obj as T;
    return undefined;
  }
  const currentStep = actualPath.shift() as string;
  if (actualPath.length === 0) return (obj as any)[currentStep] as T;
  return getValueByPath(
    (obj as any)[currentStep] as object,
    actualPath,
    separator,
  );
}
